import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-BLE3wELi-CV9fXVbx.js';
import { u as useTaktId } from '../../TaktIdContext/TaktIdContext-1m8IJOfp.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { T as TextButton } from '../../Button/TextButton/TextButton-BO8BRFov.js';

const CancelButton = ({
  onCancel,
  taktId,
  children,
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    dataTaktId
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('cancel-button')
  });
  return /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
    onClick: onCancel,
    taktId: dataTaktId
  }), children !== null && children !== void 0 ? children : formatMessage({
    id: 'cancel'
  }));
};

export { CancelButton as C };
//# sourceMappingURL=CancelButton-1OVnIE0m.js.map
